// Razorpay Configuration
// Replace these values with your actual Razorpay credentials

export const RAZORPAY_CONFIG = {
  // Test Mode Key - Get from Razorpay Dashboard
  keyId: process.env.REACT_APP_RAZORPAY_KEY_ID || "", // Razorpay Key ID from env

  // Test mode flag
  testMode: true,

  // Organization details
  name: "ISC Foundation",
  description: "Donation to ISC Foundation",
  subscriptionDescription: "Monthly Subscription Donation",

  // Currency
  currency: "INR",
    
  // Theme
  theme: {
    color: "#1c235e", // ISC Foundation brand color
  },
};

// Subscription plan configurations
export const SUBSCRIPTION_FREQUENCIES = {
  daily: {
    period: "daily",
    interval: 1,
    label: "Daily",
  },
  weekly: {
    period: "weekly",
    interval: 1,
    label: "Weekly",
  },
  monthly: {
    period: "monthly",
    interval: 1,
    label: "Monthly",
  },
};

// Minimum donation amount (in INR)
export const MIN_DONATION_AMOUNT = 100;